import React from "react";
import ContentEditable from "react-contenteditable";
import "./SelectableEditText.css";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";

class SelectableEditText extends React.Component {
  constructor(props) {
    super(props);
    this.onBlur = this.onBlur.bind(this);
    this.textRef = React.createRef();
    this.containerRef = React.createRef();
    this.getSelection = this.getSelection.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.boldClicked = this.boldClicked.bind(this);
    this.linkClicked = this.linkClicked.bind(this);
    this.rubyClicked = this.rubyClicked.bind(this);
    this.renderFloatContent = this.renderFloatContent.bind(this);
    this.applyLink = this.applyLink.bind(this);
    this.removeLink = this.removeLink.bind(this);
    this.onLinkChange = this.onLinkChange.bind(this);
    this.applyRuby = this.applyRuby.bind(this);
    this.removeRuby = this.removeRuby.bind(this);
    this.onRubyChange = this.onRubyChange.bind(this);
    this.onHtmlChange = this.onHtmlChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.setRange = this.setRange.bind(this);

    this.state = {
      btnGroupStyle: {
        visibility: "hidden",
        left: 0,
        top: 0,
        position: "absolute"
      },
      floatContent: null,
      tempLink: "",
      tempRuby: ""
    };
  }

  setRange(aRange) {
    if (aRange.startOffset > 0 || aRange.endOffset > 0) {
      window.getSelection().addRange(aRange);
      return;
    }

    try {
      let newRange = document.createRange();

      if (
        this.textRef.current.childNodes != null &&
        this.textRef.current.childNodes.length > 1
      ) {
        newRange.setStart(this.startNode, this.start);
        newRange.setEnd(this.endNode, this.end);
      } else if (
        this.textRef.current.childNodes != null &&
        this.textRef.current.childNodes.length > 0
      ) {
        newRange.setStart(this.textRef.current.firstChild, this.start);
        newRange.setEnd(this.textRef.current.firstChild, this.end);
      } else {
        return;
      }

      window.getSelection().addRange(newRange);
    } catch (e) {
      console.log(e.toString());
    }
  }

  onKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      document.execCommand("insertHTML", false, `<br><br>`);
    }
  }

  onHtmlChange(e) {
    this.props.onChange(e);
  }

  onRubyChange(e) {
    this.setState({ tempRuby: e.target.value });
  }

  applyRuby(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.cachedRange != null && this.state.tempRuby !== "") {
      window.getSelection().removeAllRanges();
      this.setRange(this.cachedRange);

      setTimeout(() => {
        let btmStr = window.getSelection().toString();
        let finalBtmStr = "";

        for (let i = 0; i < btmStr.length; i++) {
          if (!this.state.tempRuby.includes(btmStr.charAt(i))) {
            finalBtmStr = finalBtmStr + btmStr.charAt(i);
          }
        }

        document.execCommand(
          "insertHTML",
          false,
          `<ruby>${finalBtmStr}<rt>${this.state.tempRuby}</rt></ruby>`
        );
        this.clearSelection();
      }, 10);

      return;
    }

    this.clearSelection();
  }

  removeRuby(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.cachedRange != null) {
      window.getSelection().removeAllRanges();
      this.setRange(this.cachedRange);

      setTimeout(() => {
        const btmStr = window.getSelection().toString();
        document.execCommand("insertHTML", false, btmStr);
        this.clearSelection();
      }, 10);

      return;
    }

    this.clearSelection();
  }

  onLinkChange(e) {
    this.setState({ tempLink: e.target.value });
  }

  applyLink(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.cachedRange != null && this.state.tempLink !== "") {
      window.getSelection().removeAllRanges();
      this.setRange(this.cachedRange);

      setTimeout(() => {
        document.execCommand("createLink", false, this.state.tempLink);
        this.clearSelection();
      }, 10);

      return;
    }

    this.clearSelection();
  }

  removeLink(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.cachedRange != null) {
      window.getSelection().removeAllRanges();
      this.setRange(this.cachedRange);

      setTimeout(() => {
        document.execCommand("unlink", false, null);
        this.clearSelection();
      }, 10);

      return;
    }

    this.clearSelection();
  }

  boldClicked(e) {
    e.preventDefault();
    e.stopPropagation();
    document.execCommand("bold", false, null);
  }

  linkClicked(e) {
    e.preventDefault();
    e.stopPropagation();

    let selectionText = "";

    try {
      selectionText = window.getSelection().toString();
      selectionText = fullChar2halfChar(selectionText);
      selectionText = selectionText.replace(/ /g, "");

      if (
        !selectionText.startsWith("http://") &&
        !selectionText.startsWith("https://") &&
        !selectionText.startsWith("HTTPS://") &&
        !selectionText.startsWith("HTTP://")
      ) {
        if (
          !selectionText.startsWith("www.") &&
          !selectionText.startsWith("WWW.")
        ) {
          selectionText = "www." + selectionText;
        }
        selectionText = "https://" + selectionText;
      }
    } catch (e) {
      console.log(e.toString());
    }
    this.setState({ floatContent: "link", tempLink: selectionText });
  }

  rubyClicked(e) {
    e.preventDefault();
    e.stopPropagation();

    let selectionText = "";

    try {
      selectionText = window.getSelection().toString();
      selectionText = getRubyTop(selectionText);
    } catch (e) {
      console.log(e.toString());
    }

    this.setState({ floatContent: "ruby", tempRuby: selectionText });
  }

  onBlur() {
    if (this.state.floatContent == null) {
      this.clearSelection();
    }
  }

  clearSelection() {
    window.getSelection().removeAllRanges();
    this.setState({
      floatContent: null,
      btnGroupStyle: {
        visibility: "hidden",
        left: 0,
        top: 0,
        position: "absolute"
      }
    });
  }

  getSelection() {
    const selection = window.getSelection();

    let containerX;
    let containerY;

    try {
      containerX = this.containerRef.getBoundingClientRect().x;
      containerY = this.containerRef.getBoundingClientRect().y;
    } catch (e) {
      return;
    }

    if (selection != null && selection.toString().length > 0) {
      if (selection.rangeCount > 0) {
        const firstRange = selection.getRangeAt(0);
        this.cachedRange = firstRange;
        const selectionRects = firstRange.getClientRects();

        if (selectionRects != null && selectionRects.length > 0) {
          const firstRect = selectionRects[0];

          let left;
          let top;

          try {
            left = firstRect.x - containerX;
            top = firstRect.y - containerY - 35;
          } catch (e) {
            left = 0;
            top = 0;
          }

          this.start = firstRange.startOffset;
          this.end = firstRange.endOffset;
          this.startNode = firstRange.startContainer;
          this.endNode = firstRange.endContainer;

          this.setState({
            floatContent: null,
            btnGroupStyle: {
              visibility: "visible",
              left: left,
              top: top,
              position: "absolute"
            }
          });

          // For Chrome reset selection bug
          setTimeout(() => {
            if (firstRange.startOffset > 0 || firstRange.endOffset > 0) {
              return;
            }

            let newRange = document.createRange();

            if (
              this.textRef.current.childNodes != null &&
              this.textRef.current.childNodes.length > 1
            ) {
              newRange.setStart(this.startNode, this.start);
              newRange.setEnd(this.endNode, this.end);
            } else if (
              this.textRef.current.childNodes != null &&
              this.textRef.current.childNodes.length > 0
            ) {
              newRange.setStart(this.textRef.current.firstChild, this.start);
              newRange.setEnd(this.textRef.current.firstChild, this.end);
            } else {
              return;
            }

            window.getSelection().removeAllRanges();
            window.getSelection().addRange(newRange);
            this.cachedRange = newRange;
          }, 0);
        }
      }
    }
  }

  renderFloatContent() {
    const { floatContent, btnGroupStyle } = this.state;
    const { hidehtml } = this.props;

    let containerW = 616;

    if (hidehtml) {
      return null;
    }

    if (floatContent == null) {
      const style = {
        visibility: btnGroupStyle.visibility,
        left:
          btnGroupStyle.left + 85 > containerW
            ? containerW - 85 + "px"
            : btnGroupStyle.left + "px",
        top: btnGroupStyle.top + "px",
        position: btnGroupStyle.position
      };

      return (
        <div style={style}>
          <ButtonGroup size="sm">
            <Button
              size="sm"
              className="hover_text_btn"
              variant="info"
              onMouseDown={this.boldClicked}
            >
              <span className="fa fa-bold" />
            </Button>
            <Button
              size="sm"
              className="hover_text_btn"
              variant="info"
              onMouseDown={this.linkClicked}
            >
              <span className="fa fa-link" />
            </Button>
            <Button
              size="sm"
              className="hover_text_btn"
              variant="info"
              onMouseDown={this.rubyClicked}
            >
              <span className="fa fa-jpy" />
            </Button>
          </ButtonGroup>
        </div>
      );
    } else if (floatContent === "link") {
      const style = {
        visibility: btnGroupStyle.visibility,
        left:
          btnGroupStyle.left + 350 > containerW
            ? containerW - 350 + "px"
            : btnGroupStyle.left + "px",
        top: btnGroupStyle.top + "px",
        position: btnGroupStyle.position
      };

      return (
        <div style={style}>
          <InputGroup style={{ width: "350px" }}>
            <InputGroup.Prepend>
              <Button
                variant="info"
                style={{ margin: 0 }}
                onMouseDown={this.applyLink}
              >
                <span className="fa fa-check" />
              </Button>
            </InputGroup.Prepend>
            <InputGroup.Prepend>
              <Button
                variant="danger"
                style={{ margin: 0 }}
                onMouseDown={this.removeLink}
              >
                <span className="fa fa-times" />
              </Button>
            </InputGroup.Prepend>
            <Form.Control
              onMouseDown={e => {
                e.stopPropagation();
                e.target.focus();
              }}
              onChange={this.onLinkChange}
              value={this.state.tempLink}
              placeholder="https://..."
            />
          </InputGroup>
        </div>
      );
    } else if (floatContent === "ruby") {
      const style = {
        visibility: btnGroupStyle.visibility,
        left:
          btnGroupStyle.left + 250 > containerW
            ? containerW - 250 + "px"
            : btnGroupStyle.left + "px",
        top: btnGroupStyle.top + "px",
        position: btnGroupStyle.position
      };

      return (
        <div style={style}>
          <InputGroup style={{ width: "250px" }}>
            <InputGroup.Prepend>
              <Button
                variant="info"
                style={{ margin: 0 }}
                onMouseDown={this.applyRuby}
              >
                <span className="fa fa-check" />
              </Button>
            </InputGroup.Prepend>
            <InputGroup.Prepend>
              <Button
                variant="danger"
                style={{ margin: 0 }}
                onMouseDown={this.removeRuby}
              >
                <span className="fa fa-times" />
              </Button>
            </InputGroup.Prepend>
            <Form.Control
              onMouseDown={e => {
                e.stopPropagation();
                e.target.focus();
              }}
              onChange={this.onRubyChange}
              value={this.state.tempRuby}
              placeholder="Enter ruby..."
            />
          </InputGroup>
        </div>
      );
    }
  }

  render() {
    const { style } = this.props;

    const inputStyle = style == null ? {} : style;

    return (
      <div
        className="hover_text_container"
        ref={el => (this.containerRef = el)}
      >
        <ContentEditable
          className="selectable_text_area"
          onKeyDown={this.onKeyDown}
          innerRef={this.textRef}
          onFocus={this.props.onFocus}
          onBlur={this.onBlur}
          onChange={this.onHtmlChange}
          html={this.props.value.replace(/\n/g, "<br>")}
          onMouseUp={this.getSelection}
          onMouseDown={this.clearSelection}
          style={inputStyle}
        />
        {this.renderFloatContent()}
      </div>
    );
  }
}

function fullChar2halfChar(str) {
  let result = "";
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code >= 65281 && code <= 65373) {
      result += String.fromCharCode(str.charCodeAt(i) - 65248);
    } else if (code === 12288) {
      result += String.fromCharCode(32);
    } else {
      result += str.charAt(i);
    }
  }

  return result;
}

function getRubyTop(str) {
  let top = "";

  for (let i = 0; i < str.length; i++) {
    const aChar = str.charAt(i);

    if (isTopChar(aChar)) {
      top = top + aChar;
    }
  }

  return top;
}

function isTopChar(char) {
  if (char == null || char.length <= 0) {
    return false;
  }

  const charCode = char.charCodeAt(0);

  if (charCode >= 0x3041 && charCode <= 0x309f) {
    return true;
  }

  if (charCode >= 0x30a1 && charCode <= 0x30ff) {
    return true;
  }

  if (charCode >= 0x31f0 && charCode <= 0x31ff) {
    return true;
  }

  if (charCode >= 0x1b130 && charCode <= 0x1b16f) {
    return true;
  }

  if (charCode >= 0xff60 && charCode <= 0xff9f) {
    return true;
  }

  return false;
}

export default SelectableEditText;
